import React, { useState } from 'react';

const StickyCTA = ({ model, onRequestQuote, onRequestCallback, className = '' }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-2xl md:hidden ${className}`}>
      <div className="flex items-center justify-between p-4">
        {/* Modell info */}
        <div className="flex-1">
          <h3 className="font-bold text-gray-900 text-sm">{model.title}</h3>
          <p className="text-[#e31937] font-semibold text-sm">
            {new Intl.NumberFormat('hu-HU', {
              style: 'currency',
              currency: 'EUR',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(model.price_from_eur)} tól
          </p>
        </div>

        {/* CTA gombok */}
        <div className="flex space-x-2">
          <button
            onClick={onRequestCallback}
            className="bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-2 px-3 rounded-lg transition-colors text-sm"
          >
            📞 Visszahívás
          </button>
          <button
            onClick={onRequestQuote}
            className="bg-[#e31937] hover:bg-[#b40000] text-white font-semibold py-2 px-4 rounded-lg transition-colors text-sm"
          >
            Kérek ajánlatot
          </button>
        </div>

        {/* Bezárás gomb */}
        <button
          onClick={() => setIsVisible(false)}
          className="ml-2 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default StickyCTA;
